import React, { Component } from 'react'
import './App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect
} from 'react-router-dom';
import Login from './Components/Login';
import Signup from './Components/Signup';
// import Spinner from './Components/Spinner';
import About from './Components/About';
// import Header from './Components/Header';
import Map from './Components/Map';
// import { login, signup } from "./fetch-utils";


const TOKEN_KEY = 'TOKEN'
export default class App extends Component {
    state= {
        token: localStorage.getItem(TOKEN_KEY)
    }

    login = (userToken) => {
        this.setState({ token: userToken })
        localStorage.setItem(TOKEN_KEY, userToken)
    }

    logout = () => {
        this.setState({ token: '' })
        localStorage.setItem('TOKEN', '')

    }

    render() {
        return (
            <Router>
                <div className="app-header">
                    <div className="logo-section">
                        <img src="./logo.png" alt="Birdzai Logo"/>
                        <h1>Birdzai - Bird Watching App</h1>
                    </div>
                    <div className="header-links">
                        <Link to='/'>Map</Link>
                        <Link to='/login'>Login</Link>
                        <Link to='/signup'>Signup</Link>
                        <Link to='/about'>About Us</Link>
                        <button onClick={this.logout}>Logout</button>
                    </div>
                </div>

            <Switch>
            <Route
                path='/signup'
                exact
                render={(routerProps) => <Signup login={this.login} {...routerProps} />}/>
            <Route
                path='/login'
                exact
                render={(routerProps) => <Login login={this.login} {...routerProps} />}/>
            <Route
                path='/'
                exact
                render={(routerProps) =>
                this.state.token
                    ? <Map {...routerProps} token={this.state.token} />
                    : <Redirect to='/signup' />
                }
                />
            <Route
                path='/about'
                exact
                render={(routerProps) => <About {...routerProps} />}/>
            </Switch>
        </Router>
        )
    }
}



